// @flow

import type {
  ActionHandlers,
  Reducer,
  Selector,
} from '@travel-frontend/state-handling-sdk';
import type {VoucherDataState} from 'redux/v1/voucherData/voucherDataState';

import {
  createReducerUsingActionHandlers,
  ERROR,
  PENDING,
  SUCCESS,
} from '@travel-frontend/state-handling-sdk';
import {createSelector} from 'reselect';

import {voucherDataState} from 'redux/v1/V1State';
import {
  FETCH_VOUCHER_DATA,
  GetVoucherDataSuccess,
} from 'redux/v1/voucherData/actions';

export const initialState: VoucherDataState = {
  loading: false,
};

const actionCreators: ActionHandlers<VoucherDataState> = {
  [PENDING(FETCH_VOUCHER_DATA)]: (state: VoucherDataState) => ({
    ...state,
    loading: true,
  }),
  [SUCCESS(FETCH_VOUCHER_DATA)]: (
    state: VoucherDataState,
    action: GetVoucherDataSuccess
  ) => ({
    ...state,
    loading: false,
    data: action.data,
  }),
  [ERROR(FETCH_VOUCHER_DATA)]: (state: VoucherDataState, action: any) => ({
    ...state,
    loading: false,
    error: action.error,
  }),
};

export const voucherDataReducer: Reducer<VoucherDataState> =
  // $FlowIgnore
  createReducerUsingActionHandlers<VoucherDataState>(
    initialState,
    actionCreators
  );

export const getVoucherData: Selector<any> = createSelector(
  voucherDataState,
  (state: VoucherDataState) => state.data
);
